(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;

  const Kernel = window.Kernel;

  const el = U.el;
  const esc = U.esc;
  const menuCfg = U.menuCfg;
  const saveMenuCfg = U.saveMenuCfg;

  const ATTUNE_KEY = "riftbound-attune";
  const HOME_INTENT_KEY = "riftbound-home-intent";

  const SHADES = {
    none: ["#f0c46a", "#fdf0cf", "#c08a2e", "#6e5015"],
    fury: ["#ff7b6b", "#ffd4cc", "#b8483c", "#7a3a30"],
    calm: ["#7bd88f", "#d3f5da", "#3f9455", "#2c4a3a"],
    mind: ["#6bb7ff", "#cbe6ff", "#3574b5", "#26405a"],
    body: ["#ffab5e", "#ffdfbe", "#b8722f", "#5a3e1c"],
    chaos: ["#c98bff", "#e8d3ff", "#8a4fbb", "#46305a"],
    order: ["#ffe95e", "#fff8c9", "#b8a32c", "#5a531c"],
  };

  const GLYPHS = {
    fury: "M12 8.6l3.4 5.9H8.6z",
    calm: "M12 8.9a3.1 3.1 0 1 0 0 6.2 3.1 3.1 0 0 0 0-6.2z",
    mind: "M12 8.5l3.5 3.5-3.5 3.5L8.5 12z",
    body: "M8.4 10.4h7.2v3.2H8.4z",
    chaos: "M12 7.8l1.2 3 3 1.2-3 1.2-1.2 3-1.2-3-3-1.2 3-1.2z",
    order: "M12 8.4l3.1 1.8v3.6L12 15.6l-3.1-1.8v-3.6z",
  };

  const RIFT_PATH = "M300 -60 L262 150 L286 300 L232 470 L258 620 L206 800 L228 960";

  const MARK = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.2'>" +
    "<path d='M12 2l8.7 5v10L12 22l-8.7-5V7z'></path><circle cx='12' cy='12' r='3.4'></circle>" +
    "<path d='M12 5.4v3.2M12 15.4v3.2M6.3 8.7l2.8 1.6M14.9 13.7l2.8 1.6M17.7 8.7l-2.8 1.6M9.1 13.7l-2.8 1.6'></path></svg>";
  const CHEVRONS = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'><path d='M6 5l7 7-7 7M14 5l6 7-6 7'></path></svg>";
  const PLAY_ICO = "<svg viewBox='0 0 24 24' fill='currentColor'><path d='M7 4l13 8-13 8z'></path></svg>";
  const USER_ICO = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5'><circle cx='12' cy='8.4' r='3.4'></circle><path d='M5.4 19.6c0-3.4 3-5.6 6.6-5.6s6.6 2.2 6.6 5.6'></path></svg>";

  const PLATE_ICONS = {
    decks: "<svg class='hmplateico' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5'><path d='M7.5 4.5h9v15h-9z'></path><path d='M4.6 7.2L3 7.7l3.2 11.6 1.6-.5'></path><path d='M19.4 7.2L21 7.7l-3.2 11.6-1.6-.5'></path></svg>",
    bench: "<svg class='hmplateico' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5'><path d='M12 3l7.4 2.6v6c0 4.3-3 7.6-7.4 9.4-4.4-1.8-7.4-5.1-7.4-9.4v-6z'></path><path d='M8.8 12l2.2 2.3 4.2-4.6'></path></svg>",
    trainer: "<svg class='hmplateico' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5'><path d='M4 19h16'></path><path d='M4.6 15.2l4.6-5.1 3.4 2.8 5.4-6.7'></path><circle cx='9.2' cy='10.1' r='1.3'></circle><circle cx='12.6' cy='12.9' r='1.3'></circle></svg>",
    metagame: "<svg class='hmplateico' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5'><path d='M4 4h16v16H4z'></path><path d='M4 9.3h16M4 14.7h16M9.3 4v16M14.7 4v16'></path></svg>",
  };

  const S = { games: null, fields: null, asked: false };

  function localTools() { return !!document.getElementById("localtools"); }

  function attuned() {
    let v = null;
    try { v = localStorage.getItem(ATTUNE_KEY); } catch (e) { }
    return SHADES[v] ? v : "none";
  }

  function setAttuned(v) {
    try {
      if (v === "none") localStorage.removeItem(ATTUNE_KEY);
      else localStorage.setItem(ATTUNE_KEY, v);
    } catch (e) { }
    U.render();
  }

  function shades(key) {
    const s = SHADES[key] || SHADES.none;
    return { mid: s[0], hi: s[1], lo: s[2], line: s[3], s22: s[0] + "38", s40: s[0] + "66", s90: s[0] + "e0" };
  }

  function tintStyle(a) {
    return "--acc:" + a.mid + ";--accHi:" + a.hi + ";--accLo:" + a.lo + ";--accLine:" + a.line +
      ";--accS22:" + a.s22 + ";--accS40:" + a.s40 + ";--accS90:" + a.s90;
  }

  function scriptedCount() {
    return Object.keys(RB.CardScripts || {}).length;
  }

  function setBreakdown() {
    if (setBreakdown.cache) return setBreakdown.cache;
    const by = {};
    for (const c of window.CARD_DB) by[c.set] = (by[c.set] || 0) + 1;
    const out = Object.keys(by).map(function (id) { return { id: id, n: by[id] }; });
    out.sort(function (x, y) { return y.n - x.n || x.id.localeCompare(y.id); });
    setBreakdown.cache = out;
    return out;
  }

  function fetchStats() {
    if (S.asked) return;
    S.asked = true;
    if (!localTools()) return;
    const done = function () { if (APP.screen === "home") U.render(); };
    fetch("/api/trainer/games").then(function (r) { return r.ok ? r.json() : []; })
      .then(function (j) { S.games = Array.isArray(j) ? j : []; done(); })
      .catch(function () { S.games = []; done(); });
    fetch("/api/meta/fields").then(function (r) { return r.ok ? r.json() : []; })
      .then(function (j) { S.fields = Array.isArray(j) ? j : []; done(); })
      .catch(function () { S.fields = []; done(); });
  }

  function biggestField() {
    let best = null;
    for (const f of S.fields || []) {
      const n = (f.entries || []).length;
      if (!n) continue;
      if (!best || n > best.n) best = { n: n, name: f.name || f.id };
    }
    return best;
  }

  function stat(n, label) {
    const s = el("div", "hmstat");
    s.appendChild(el("span", "hmstatn", esc(String(n))));
    s.appendChild(el("span", "hmstatl", esc(label)));
    return s;
  }

  function keyart() {
    const wrap = el("div", "hmkeyart");
    wrap.innerHTML =
      "<svg viewBox='0 0 780 900' preserveAspectRatio='xMidYMid slice' fill='none' aria-hidden='true'>" +
      "<defs>" +
      "<linearGradient id='hmriftg' x1='0' y1='0' x2='0' y2='1'>" +
      "<stop offset='0' stop-color='currentColor' stop-opacity='0'></stop>" +
      "<stop offset='0.2' stop-color='currentColor' stop-opacity='0.85'></stop>" +
      "<stop offset='0.58' stop-color='currentColor' stop-opacity='1'></stop>" +
      "<stop offset='1' stop-color='currentColor' stop-opacity='0'></stop>" +
      "</linearGradient>" +
      "<linearGradient id='hmshardg' x1='0' y1='0' x2='1' y2='1'>" +
      "<stop offset='0' stop-color='currentColor' stop-opacity='0.5'></stop>" +
      "<stop offset='1' stop-color='currentColor' stop-opacity='0'></stop>" +
      "</linearGradient>" +
      "<radialGradient id='hmfade' cx='0.42' cy='0.5' r='0.62'>" +
      "<stop offset='0' stop-color='#ffffff' stop-opacity='0.9'></stop>" +
      "<stop offset='1' stop-color='#ffffff' stop-opacity='0'></stop>" +
      "</radialGradient>" +
      "<filter id='hmsoft' x='-60%' y='-30%' width='220%' height='160%'><feGaussianBlur stdDeviation='26'></feGaussianBlur></filter>" +
      "<filter id='hmsoft2' x='-60%' y='-30%' width='220%' height='160%'><feGaussianBlur stdDeviation='7'></feGaussianBlur></filter>" +
      "<pattern id='hmhexp' width='46' height='80' patternUnits='userSpaceOnUse'>" +
      "<path d='M23 2 L44 14 L44 38 L23 50 L2 38 L2 14 Z' stroke='currentColor' stroke-opacity='0.5' stroke-width='0.8' fill='none'></path>" +
      "<path d='M0 42 L21 54 L21 78 L0 90' stroke='currentColor' stroke-opacity='0.5' stroke-width='0.8' fill='none'></path>" +
      "<path d='M46 42 L25 54 L25 78 L46 90' stroke='currentColor' stroke-opacity='0.5' stroke-width='0.8' fill='none'></path>" +
      "</pattern>" +
      "<mask id='hmhexm'><rect x='0' y='0' width='780' height='900' fill='url(#hmfade)'></rect></mask>" +
      "<path id='hmriftbase' pathLength='1000' d='" + RIFT_PATH + "'></path>" +
      "<path id='hmriftlive' pathLength='1000' d='" + RIFT_PATH + "'></path>" +
      "</defs>" +
      "<g mask='url(#hmhexm)' opacity='0.3'><rect x='120' y='0' width='660' height='900' fill='url(#hmhexp)'></rect></g>" +
      "<g class='hmriftwide' opacity='0.5' filter='url(#hmsoft)' stroke='url(#hmriftg)' stroke-width='54' stroke-linecap='round'><use href='#hmriftbase'></use></g>" +
      "<g class='hmriftmid' opacity='0.72' filter='url(#hmsoft2)' stroke='url(#hmriftg)' stroke-width='9' stroke-linecap='round'><use href='#hmriftlive'></use></g>" +
      "<g class='hmriftfil' stroke='url(#hmriftg)' stroke-width='1.6'><use href='#hmriftlive'></use></g>" +
      "<g class='hmcomet' opacity='0' filter='url(#hmsoft2)' stroke-width='5' stroke-linecap='round' stroke-dasharray='70 1000' stroke-dashoffset='70'><use href='#hmriftlive'></use></g>" +
      "<g fill='url(#hmshardg)' opacity='0.62'>" +
      "<path d='M264 148 L372 96 L296 214 Z'></path><path d='M284 300 L196 246 L268 356 Z'></path>" +
      "<path d='M234 468 L358 428 L262 552 Z'></path><path d='M256 620 L166 578 L240 700 Z'></path>" +
      "<path d='M208 796 L318 764 L232 872 Z'></path><path d='M290 24 L206 -8 L272 108 Z'></path>" +
      "</g>" +
      "<g stroke='currentColor' stroke-opacity='0.34' stroke-width='1'>" +
      "<path d='M264 148 L372 96'></path><path d='M234 468 L358 428'></path>" +
      "<path d='M284 300 L196 246'></path><path d='M208 796 L318 764'></path>" +
      "</g>" +
      "<g fill='currentColor' opacity='0.5'>" +
      "<circle cx='392' cy='88' r='2'></circle><circle cx='176' cy='250' r='1.5'></circle>" +
      "<circle cx='380' cy='424' r='2.4'></circle><circle cx='150' cy='576' r='1.6'></circle>" +
      "<circle cx='336' cy='760' r='2'></circle>" +
      "</g><g class='hmembers'></g></svg>";
    return wrap;
  }

  function rail(key) {
    const r = el("div", "hmrail");
    const mark = el("div", "hmmark", MARK);
    mark.appendChild(el("span", "hmmarkw", "SIMULATOR"));
    r.appendChild(mark);

    const attune = el("div", "hmattune");
    attune.appendChild(el("span", "mslbl", "Attune"));
    const pips = el("div", "hmpips");
    for (const dom of Core.DOMAINS) {
      (function (dom) {
        const s = shades(dom);
        const on = key === dom;
        const b = el("button", "hmpip" + (on ? " on" : ""),
          "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.3'>" +
          "<path d='M12 3.2l7.6 4.4v8.8L12 20.8l-7.6-4.4V7.6z'></path>" +
          "<path d='" + GLYPHS[dom] + "' fill='currentColor' stroke='none'></path></svg>");
        b.setAttribute("style", "--p:" + s.mid + ";--pS90:" + s.s90);
        b.title = dom.charAt(0).toUpperCase() + dom.slice(1) + (on ? " — click to clear" : "");
        b.onclick = function () {
          const next = on ? "none" : dom;
          RB.Rift.arm(next, b);
          setAttuned(next);
        };
        pips.appendChild(b);
      })(dom);
    }
    attune.appendChild(pips);
    r.appendChild(attune);

    const stats = el("div", "hmrailstats");
    stats.appendChild(stat(Kernel.ENGINE_VERSION, "Engine"));
    stats.appendChild(stat(window.CARD_DB.length, "Cards"));
    stats.appendChild(stat(scriptedCount(), "Scripted"));
    stats.appendChild(stat(setBreakdown().length, "Sets"));
    r.appendChild(stats);
    r.appendChild(el("div", "mshair"));
    return r;
  }

  function playPlate(cfg, key) {
    const b = el("button", "hmplay");
    b.appendChild(el("span", "hmplayfill"));
    b.appendChild(el("span", "hmplayseal",
      "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.15'>" +
      "<path d='M12 1.9l8.7 5v10L12 21.9l-8.7-5v-10z'></path>" +
      (GLYPHS[key]
        ? "<path d='" + GLYPHS[key] + "' fill='currentColor' stroke='none'></path>"
        : "<path d='M12 7.4l4 2.3v4.6l-4 2.3-4-2.3V9.7z'></path>") + "</svg>"));
    const text = el("span", "hmplaytext");
    text.appendChild(el("span", "hmplayw", "PLAY"));
    const trk = el("span", "hmplaytrack");
    for (let i = 0; i < 8; i++) {
      const pip = el("i", "hmplaypip");
      pip.style.transitionDelay = (i * 38) + "ms";
      trk.appendChild(pip);
    }
    text.appendChild(trk);
    text.appendChild(el("span", "hmplaysub", "Conquer, hold, first to eight"));
    b.appendChild(text);
    b.appendChild(el("span", "hmplaygo", CHEVRONS));
    b.title = cfg.best > 1 ? "Standard 1v1 match · best of " + cfg.best : "Standard 1v1 duel";
    b.onmouseenter = function () { RB.Rift.burst(b, true); };
    b.onclick = function () {
      RB.Rift.burst(b, false);
      setTimeout(function () { location.href = "/play"; }, 170);
    };
    return b;
  }

  function hero(cfg, key) {
    const h = el("div", "hmhero");
    const over = el("div", "hmheroover");
    over.appendChild(el("span", "mslbl", cfg.best > 1 ? "Standard 1v1 match · Bo" + cfg.best : "Standard 1v1 duel"));
    over.appendChild(el("span", "hmheroline"));
    h.appendChild(over);
    h.appendChild(el("div", "hmwordmark", "RIFTBOUND"));
    h.appendChild(playPlate(cfg, key));
    return h;
  }

  function ribbon(title, right) {
    return U.lineRib("hmribbon", "hmrib", title, right);
  }

  function ribbonLabel(text) { return el("span", "hmribt", esc(text)); }

  function handOff(cfg, intent) {
    saveMenuCfg(cfg);
    try { localStorage.setItem(HOME_INTENT_KEY, intent); } catch (e) { }
    location.href = "/play";
  }

  function plate(kind, title, desc, n, unit, href, localOnly) {
    const p = el("button", "hmplate", PLATE_ICONS[kind]);
    p.appendChild(el("span", "hmplatet", esc(title)));
    p.appendChild(el("span", "hmplated", esc(desc)));
    const foot = el("span", "hmplatefoot");
    foot.appendChild(el("span", "hmplaten", n === null ? "—" : esc(String(n))));
    foot.appendChild(el("span", "hmplatel", esc(unit)));
    p.appendChild(foot);
    if (localOnly) p.appendChild(el("span", "hmplatelocal", "LOCAL ONLY"));
    p.onclick = function () { location.href = href; };
    return p;
  }

  function plates(info) {
    const row = el("div", "hmplates");
    row.appendChild(plate("decks", "DECKS", "Tournament lists, precons and your own builds.",
      RB.Decklists.all().length, "lists indexed", U.DECK_LIST_PATH, false));
    if (!info || info.testbench !== false) {
      row.appendChild(plate("bench", "BENCH", "Card verification scenarios and verdicts.",
        scriptedCount(), "cards scripted", "/testbench", false));
    }
    if (localTools()) {
      row.appendChild(plate("trainer", "TRAINER", "Review your games, run the lab, tune the pilots.",
        S.games ? S.games.length : null, "games saved", "/trainer", true));
      const f = biggestField();
      row.appendChild(plate("metagame", "METAGAME", "Tier list and matchup matrix for the current field.",
        f ? f.n : null, f ? f.name + " entries" : "field entries", "/metagame", true));
    }
    return row;
  }

  function savedAt() {
    let raw = null;
    try { raw = localStorage.getItem(U.AUTOSAVE_AT_KEY); } catch (e) { }
    const t = Number(raw);
    if (!t) return null;
    const d = new Date(t);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const pad = function (n) { return String(n).padStart(2, "0"); };
    return d.getDate() + " " + months[d.getMonth()] + ", " + pad(d.getHours()) + ":" + pad(d.getMinutes());
  }

  function track(name, points, target, foe) {
    const row = el("div", "hmscore" + (foe ? " foe" : ""));
    row.appendChild(el("span", "hmscoren", esc(name)));
    const bar = el("div", "hmtrackbar");
    const fill = el("div", "hmtrackfill");
    fill.style.width = Math.max(0, Math.min(100, (points / target) * 100)) + "%";
    bar.appendChild(fill);
    for (let i = 1; i < target; i++) {
      const pip = el("span", "hmtrackpip");
      pip.style.left = (i / target) * 100 + "%";
      bar.appendChild(pip);
    }
    row.appendChild(bar);
    row.appendChild(el("span", "hmscorev", esc(String(points)) + "<i>/" + target + "</i>"));
    return row;
  }

  function legendFace(st, p, flip) {
    const pl = st.players[p];
    const card = pl && pl.legendIid ? Core.card(st, pl.legendIid) : null;
    const face = el("div", "hmface" + (flip ? " flip" : ""));
    face.appendChild(U.cardTile(card, "hmfacea", "120px"));
    face.appendChild(el("span", "hmfacel", esc(card ? card.name.split(",")[0] : "no legend")));
    return face;
  }

  function legendDuel(st) {
    const row = el("div", "hmlegends");
    row.appendChild(legendFace(st, 0, false));
    row.appendChild(el("span", "hmresumev", "VS"));
    row.appendChild(legendFace(st, 1, true));
    return row;
  }

  function resumePane() {
    const pane = el("div", "mspane msbev hmrpane");
    const inner = el("div", "mspanein msbev");
    pane.appendChild(inner);
    const match = APP.match && !APP.match.online && RB.Match.isMatch(APP.match) && !APP.match.over && APP.match.games.length
      ? APP.match : null;
    const game = APP.game && APP.state ? APP.game : null;
    const when = game ? savedAt() : null;
    inner.appendChild(ribbon("Resume", ribbonLabel(when || (game || match ? "in progress" : "no game yet"))));
    const body = el("div", "hmrbody");
    inner.appendChild(body);

    if (!game && !match) {
      body.appendChild(el("div", "hmempty", "Nothing in progress. Pick a deck, pick an opponent, and the duel starts here."));
      return pane;
    }

    const st = APP.state;
    if (game && st) {
      const head = el("div", "hmresumehead");
      head.appendChild(el("span", "hmresumen", esc(st.players[0].name)));
      head.appendChild(el("span", "hmresumev", "VS"));
      head.appendChild(el("span", "hmresumen", esc(st.players[1].name)));
      body.appendChild(head);

      const meta = el("div", "hmmetarow");
      meta.appendChild(el("span", "hmmchip", APP.net ? "Online table" : match ? "Match game " + APP.match.gameNo : "Local table"));
      meta.appendChild(el("span", "hmmchip", esc(game.log.length + " actions")));
      if (st.over) meta.appendChild(el("span", "hmmchip", esc(st.players[st.over.winner].name + " won")));
      const stale = Kernel.checkVersion(game);
      if (stale) {
        const c = el("span", "hmmchip warn", esc("Saved on engine " + (game.version === undefined ? 1 : game.version)));
        c.title = stale;
        meta.appendChild(c);
      }
      body.appendChild(meta);

      const target = Core.victoryScore(st);
      const scores = el("div", "hmscores");
      scores.appendChild(track(st.players[0].name, st.players[0].points, target, false));
      scores.appendChild(track(st.players[1].name, st.players[1].points, target, true));
      body.appendChild(scores);
      body.appendChild(legendDuel(st));
    } else if (match) {
      body.appendChild(el("div", "hmresumehead",
        "<span class='hmresumen'>" + esc(RB.Match.label(match)) + "</span>"));
      body.appendChild(el("div", "hmmetarow",
        "<span class='hmmchip'>Game " + match.gameNo + "</span><span class='hmmchip'>" + esc(RB.Match.score(match)) + "</span>"));
      body.appendChild(el("div", "hmempty", "The match is between games — side deck, then present a battlefield."));
    }

    const btns = el("div", "hmbtnrow");
    const midGame = game && (!match || (!APP.match.pending && game.setup && game.setup.match));
    const cont = el("button", "hmbtn acc", PLAY_ICO + "Continue");
    cont.onclick = function () {
      APP.error = null;
      if (!midGame && match) { U.matchPrepStep(); return; }
      APP.screen = "game";
      U.render();
    };
    btns.appendChild(cont);
    if (game) {
      const review = el("button", "hmbtn", "Review");
      review.title = "Open the game with the replay bar and step through the log";
      review.onclick = function () {
        APP.error = null;
        APP.screen = "game";
        U.setShowReplay(true);
      };
      btns.appendChild(review);
      const exp = el("button", "hmbtn", "Export");
      exp.title = "Download this game as {setup, log} JSON";
      exp.onclick = function () { U.exportGame(); };
      btns.appendChild(exp);
    }
    body.appendChild(btns);
    return pane;
  }

  function tablesPane(cfg) {
    const L = RB.Online.Lobby;
    const pane = el("div", "mspane msbev hmrpane");
    const inner = el("div", "mspanein msbev");
    pane.appendChild(inner);
    const open = L.S.listed ? L.S.list.length : null;
    inner.appendChild(ribbon("Online tables", ribbonLabel(open === null ? "looking…" : open + " open")));
    const body = el("div", "hmrbody");
    inner.appendChild(body);

    if (L.S.listErr) {
      body.appendChild(el("div", "hmempty bad", esc(L.S.listErr)));
    } else if (!L.S.listed) {
      body.appendChild(el("div", "hmempty", "Looking for tables…"));
    } else if (!L.S.list.length) {
      body.appendChild(el("div", "hmempty", "No open table right now — host one below."));
    } else {
      const list = el("div", "hmtables");
      for (const lobby of L.S.list) {
        (function (lobby) {
          const seats = lobby.seats.filter(function (s) { return s; });
          const full = lobby.seats.every(function (s) { return s; });
          const row = el("div", "hmtable" + (full ? " full" : ""));
          row.appendChild(el("span", "hmtavatar", USER_ICO));
          const meta = el("span", "hmtmeta");
          meta.appendChild(el("span", "hmtname", esc(lobby.name || (seats[0] ? seats[0].name : "Open table"))));
          meta.appendChild(el("span", "hmtsub", esc(
            (seats.map(function (s) { return s.name; }).join(" · ") || "empty") +
            (lobby.best > 1 ? " · Bo" + lobby.best : "") + " · " + seats.length + "/2")));
          row.appendChild(meta);
          row.appendChild(el("span", "hmtjoin", full ? "FULL" : "JOIN"));
          if (!full) row.onclick = function () { location.href = "/online/lobby/" + lobby.id; };
          list.appendChild(row);
        })(lobby);
      }
      body.appendChild(list);
    }
    body.appendChild(el("div", "hmempty", "Rooms live in memory and die with the process — no spectators, no persistence."));

    const btns = el("div", "hmbtnrow");
    const host = el("button", "hmbtn acc", "Host a table");
    host.onclick = function () {
      cfg.foe = "online";
      cfg.seats[1].ai = U.foePilot(cfg);
      handOff(cfg, "online");
    };
    btns.appendChild(host);
    body.appendChild(btns);
    return pane;
  }

  function renderHome() {
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const cfg = menuCfg();
    const L = RB.Online.Lobby;
    L.onChange(function () { if (APP.screen === "home") U.render(); });
    L.fetchInfo();
    L.watchList(true);
    const info = U.nativeInfo(function () { if (APP.screen === "home") U.render(); });
    fetchStats();

    const key = attuned();
    const a = shades(key);
    const wrap = el("div", "msui hmui");
    wrap.id = "homescreen";
    wrap.setAttribute("style", tintStyle(a));
    wrap.appendChild(keyart());
    wrap.appendChild(el("div", "msweave"));
    wrap.appendChild(el("div", "hmvig"));
    wrap.appendChild(rail(key));

    const err = APP.error || L.S.err;
    if (err) wrap.appendChild(el("div", "menuerr", "⚠ " + esc(err)));

    const body = el("div", "hmbody");
    const left = el("div", "hmcol hmleft");
    left.appendChild(hero(cfg, key));
    left.appendChild(plates(info));
    body.appendChild(left);

    const right = el("div", "hmcol hmright");
    right.appendChild(resumePane());
    right.appendChild(tablesPane(cfg));
    body.appendChild(right);

    wrap.appendChild(body);
    root.appendChild(wrap);
    RB.Rift.mount(key, a.mid);
  }

  Object.assign(U, { renderHome: renderHome, HOME_INTENT_KEY: HOME_INTENT_KEY });
})();
